import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetSmsSent(club, page) {

  var url = "/sms_api/get_sms_sent/" + club + "/" + page;
  return FetchGetDataWithAuthNEW(url);
}